module.exports = __webpack_public_path__ + "static/media/undraw_interaction_design_odgc.b8099eac.svg";